module.exports = __webpack_public_path__ + "img/1eb7c52.png";